// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Cleave from 'cleave.js/dist/cleave-react';

import inputStyle from '../../assets/styles/input.scss';
import style from './InputPrice.scss';

type Props = {
  name: string;
  className?: string;
  hasError?: boolean;
  errors?: string[];
  value: string;
  handleFocusInputText?: (e: Event) => void;
  handleChangeCleave: (e: Event) => void;
  handleBlurCleave: (e: Event) => void;
  handleInit: (cleave: Cleave) => void;
  handleRef?: (ref: any) => void;
};

export default class InputPrice extends Component<Props> {
  isAppleMobile: boolean = true;

  componentDidMount() {
    this.isAppleMobile = /iPad|iPhone|iPod/i.test(navigator.userAgent);
  }

  render() {
    const {
      className, hasError, value, handleFocusInputText, name,
      handleChangeCleave, handleBlurCleave, handleInit, errors, handleRef,
    } = this.props;
    return (
      <section className={style.inputPriceWrap}>
        <span className={classNames(style.currency,
          { [style.red]: !!hasError && !!errors && errors[0] !== 'unscrapped' },
          { [style.yellow]: !!errors && errors[0] === 'unscrapped' },
          { [style.filled]: !!value })}>$</span>
        <Cleave className={classNames(inputStyle.input, style.price, className,
          { [inputStyle.red]: !!hasError && !!errors && errors[0] !== 'unscrapped' },
          { [inputStyle.yellow]: !!errors && errors[0] === 'unscrapped' },
          { [inputStyle.lightBlue]: !!value })}
                type={this.isAppleMobile ? 'text' : 'tel'}
                name={name}
                value={value}
                options={{
                  numeral: true,
                  numeralThousandsGroupStyle: 'thousand',
                  numeralDecimalScale: 2,
                  numeralPositiveOnly: true,
                }}
                onFocus={(e: Event) => handleFocusInputText ? handleFocusInputText(e) : undefined}
                onChange={handleChangeCleave}
                onBlur={handleBlurCleave}
                onInit={handleInit}
                htmlRef={handleRef}/>
      </section>
    );
  }
}

InputPrice.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  hasError: PropTypes.bool,
  errors: PropTypes.array,
  value: PropTypes.string,
  handleFocusInputText: PropTypes.func,
  handleChangeCleave: PropTypes.func.isRequired,
  handleBlurCleave: PropTypes.func.isRequired,
  handleInit: PropTypes.func.isRequired,
  handleRef: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/elements/InputPrice/InputPrice.jsx